module.exports = __webpack_public_path__ + "static/media/bluetooth.5ab98ae9.svg";